<template>
  <div class="container">
    <div class="top-label">
      <span>Inbound Assigned Business
        <span class="refresh-icon" @click="refreshList()"><i :class="{'fas fa-sync-alt':true, 'fa-spin':driverInbound.loading}"></i> <span class="tooltiptext">Refresh</span></span>
      </span>
    </div>

    <div class="driver-container" @scroll="loadMoreDrivers">
      <div class="staging-lots">
        <div class="filter-container">
          <select name="iab" class="filter-license" v-model="licenseType">
            <option value="all">TNC / TCP</option>
            <option value="tnc">TNC</option>
            <option value="tcp">TCP</option>
          </select>
        </div>
      <div class="loader" v-show="driverInbound.loading">
        <i class="fa fa-spinner fa-spin"></i>
      </div>
      <div class="staging-area-error" v-show="driverInbound.error">
        There are no drivers listed in Inbound Assigned Business.
      </div>
      </div>
      <table>
        <thead v-show="!driverInbound.loading && (!driverInbound.error && !driverInbound.loading)">
          <tr class="table-header">
          <th></th>
          <th>ID</th>
          <th>ETA</th>
          <th>NAME</th>
          <th>PAX</th>
          </tr>
        </thead>
        <tbody>
          <tr class="driver" v-for="(driver, index) in drivers" :key="index">
            <td><input type="radio" :value="driver.id+'-'+driver.reservationID" v-model="selectedDriver"></td>
            <td><a :href="'#/reservation/' + driver.reservationID" target="_blank">{{driver.reservationID}}</a></td>
            <td>{{driver.eta}}</td>
            <td><a :href="'#/provider/' + driver.id" target="_blank"><span>{{driver.name}}</span></a></td>
            <td>{{driver.pax}}</td>
          </tr>
        </tbody>
      </table>
      <transition name="slide-up">
        <div class="infinity-loader" v-show="loading && drivers.length > 0">
          <i class="fas fa-spinner fa-spin"></i> Loading
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import ApiLaxitReservations from '@/modules/api/laxit/reservations'

export default {
  name: "driver-inbound",
  data() {
    return {
      driverInbound: {
        loading: true,
        error: false
      }
    }
  },
  computed: {
    loading () { return this.$store.state.laxit.driverInbound.isLoading },
    drivers () { return this.$store.state.laxit.driverInbound.list },
    selectedDriver: {
      get () { return this.$store.state.laxit.selectedDriver },
      set (value) { this.$store.commit('laxit/setSelectedDriver', value) }
    },
    licenseType: {
      get () { return this.$store.state.laxit.driverInbound.licenseType },
      set (value) {
        this.driverInbound.error = false
        this.$store.commit('laxit/resetdriverInboundList')
        this.$store.commit('laxit/setdriverInboundLicenseType', value)
        this.getList()
        }
    },
    isLastPage () {
      let driverInbound = this.$store.state.laxit.driverInbound
      return (driverInbound.currentPage * driverInbound.perPage) >= driverInbound.maxList
    }
  },
  methods: {
    getList () {
      let self = this
      self.driverInbound.error = false
      self.driverInbound.loading = true
      let isAllPackage = []
      if (self.loading) { return }

      self.$store.commit('laxit/setdriverInboundIsLoading', true)
      ApiLaxitReservations.getInbound(self, res => {
        self.$store.commit('laxit/setdriverInboundIsLoading', false)
          if (res.error || res.list.length <= 0 || res.list.length == isAllPackage.length) {
            self.driverInbound.error = true
            self.driverInbound.loading = false
            return
          }
        for(let i=0; i < res.list.length; i++) {
          if(res.list[i].type=='package') {
            isAllPackage.push(res.list[i].type)
          }
        }

        self.driverInbound.loading = false
      })
    },
    refreshList () {
      this.$store.commit('laxit/resetdriverInboundList')
      this.$store.commit('laxit/setdriverInboundCurrentPage', 1)
      this.getList()
    },
    loadMoreDrivers(event) {
      let scrollAndView = event.target.scrollTop + event.target.offsetHeight
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.isLastPage || this.loading) { return }
         this.$store.commit('laxit/setdriverInboundCurrentPage', this.$store.state.laxit.driverInbound.currentPage + 1)
         this.getList()
      }
    }
  },
  mounted() {
    let self = this
    self.$store.commit('laxit/resetdriverInboundList')
    self.getList()
  }
};
</script>

<style lang="scss" scoped>
.container {
  border: 1px solid rgba(0, 0, 0, 0.1);
  position:relative;

  .top-label {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #0d79f2;
    color: #fff;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);

    .refresh-icon {
      i{ margin-left: 5px; }
      .tooltiptext {
        visibility: hidden;
        width: 80px;
        background-color: #4e4e4e;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 1px 0;
        position: absolute;
        z-index: 1;
        opacity: 0;
        transition: opacity .6s;
        top: 120%;
        left: 60%;
        font-size: 14px;
      }
      &:hover {
        cursor: pointer;
        color: #26D97A;

        & .tooltiptext {
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }

  .driver-container {
    overflow-y: auto;
    margin-top: 30px;
    height: calc((100vh - 110px) / 2);
    padding: 10px;

    .filter-container {
      text-align: right;

      .filter-license {
        width: 100px;
        margin-bottom: 8px;
      }
    }


    table {
      width: 100%;
      border-collapse: collapse;

      .table-header{
        color: #8DA0A9;
        font-size: 11px;
        border: 1px solid rgba(0,0,0,0.3);
        background-color: #f5f5f5;

        & th{ padding: 5px 10px;  }
      }

      tr:nth-child(even) {
        background-color: #f3f3f3;
      }
      td {
        font-size: 12px;
        padding: 5px;
        text-align: center;
      }
      tbody tr:hover {
        background-color: #fff8dc;
      }
    }
  }
  }

  .staging-lots {

  & .loader {
    text-align: center;
    font-weight: 700;
    padding: 15px;
  }
}

.staging-area-error {
  text-align: center;
  padding: 20px 0;
  font-weight: 700;
  color: #F20D0D;
}

.driver{
background-color: #fff;
border: 1px solid rgba(0,0,0,0.3);
position: relative;

& td{
  padding: 10px;
  text-align: center;
  font-size: 12px;
  margin-bottom: 5px;

  & input{
    margin-top: 0;
    width: 13px;
  }
}

& a{ font-weight: 700; }
}

.infinity-loader{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background: rgba(0,0,0, .6);
  color: #fff;
  transform-origin: bottom center;
  text-align: center;
  font-size: 18px;
  line-height: 40px;
}

@media screen and (max-width: 430px) {
  .top-label {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Laxit/DriverInbound.vue